import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["assetId", "parentId", "playlistId"],
  _excluded2 = ["data"];
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from 'react-query';
import i18n from 'i18n';
import api from 'utils/api';
import assetKeys from './queryKeys';
import getFullUserName from 'utils/getFullUserName';
import getUserInspectorLink from 'utils/getUserInspectorLink';
import isAdmin from 'utils/session/isAdmin';
function fetchAssetPopularUsers(_x) {
  return _fetchAssetPopularUsers.apply(this, arguments);
}
function _fetchAssetPopularUsers() {
  _fetchAssetPopularUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var assetId, parentId, playlistId, q, resp;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          assetId = _ref.assetId, parentId = _ref.parentId, playlistId = _ref.playlistId;
          q = {
            fields: ['_count', {
              session: {
                user: ['name', 'id', 'first_name', 'last_name']
              }
            }],
            filter: {
              action: 'open',
              category: 'asset',
              session: {
                user: {
                  '-id': null // Ensure User is not null
                }
              }
            },
            groupby: 'session.user_id',
            orderby: '_count DESC',
            limit: 25
          };
          if (assetId) {
            q.filter.ref_id = assetId;
          }
          if (parentId) {
            q.filter.asset = {
              id: assetId,
              parentId: parentId
            };
          } else if (playlistId) {
            q.filter.commonAsset = {
              assetCollections: {
                collectionId: playlistId
              }
            };
          }
          _context2.next = 6;
          return api('get', '/api/query/events', q);
        case 6:
          resp = _context2.sent;
          return _context2.abrupt("return", resp.items.map(function (item) {
            var _getFullUserName;
            var openString = i18n.t('analytics_open', {
              count: item._count
            });
            var user = item.session.user;
            var title = (_getFullUserName = getFullUserName(user)) !== null && _getFullUserName !== void 0 ? _getFullUserName : user.name;
            return {
              icon: 'user',
              title: title.trim(),
              tooltip: user.name,
              value: openString,
              link: getUserInspectorLink(user)
            };
          }));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchAssetPopularUsers.apply(this, arguments);
}
function useFetchAssetPopularUsers(_ref2) {
  var assetId = _ref2.assetId,
    parentId = _ref2.parentId,
    playlistId = _ref2.playlistId,
    queryOptions = _objectWithoutProperties(_ref2, _excluded);
  function getAsset() {
    return _getAsset.apply(this, arguments);
  }
  function _getAsset() {
    _getAsset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", fetchAssetPopularUsers({
              assetId: assetId,
              parentId: parentId,
              playlistId: playlistId
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getAsset.apply(this, arguments);
  }
  var _useQuery = useQuery(assetKeys.assetPopularUsers(assetId, parentId, playlistId), getAsset, _objectSpread(_objectSpread({
      enabled: isAdmin()
    }, queryOptions), {}, {
      staleTime: 5 * 60 * 1000
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
}
export default useFetchAssetPopularUsers;